import { SelectProps } from 'antd';
import Decimal from 'decimal.js';
export enum TimeEnum {
  Ms='ms',
  S='s',
  Min='min'
}
export enum MemoryEnum {
  KB='KB',
  MB='MB',
  GB='GB'
}
export enum ProportionEnum {
  Hundred='%',
  Thousand='‰',
  TenThousand='‱'
}
// '%', '‰', '‱'

export const  PROPORTION_UNIT_OPTIONS: SelectProps['options'] = [
  { label: '百分比', value: ProportionEnum.Hundred },
  { label: '千分比', value: ProportionEnum.Thousand },
  { label: '万分比', value: ProportionEnum.TenThousand },
];

export const  TIME_UNIT_OPTIONS: SelectProps['options'] = [
  { label: '毫秒', value: TimeEnum.Ms },
  { label: '秒', value: TimeEnum.S },
  { label: '分钟', value: TimeEnum.Min },
];

export const  MEMORY_UNIT_OPTIONS: SelectProps['options'] = [
  { label: 'KB', value: MemoryEnum.KB },
  { label: 'MB', value: MemoryEnum.MB },
  { label: 'GB', value: MemoryEnum.GB },
];

export const  isTimeUnit = (value: any) => TIME_UNIT_OPTIONS.some(item => item.value === value);

export const isMemoryUnit = (value: any) => MEMORY_UNIT_OPTIONS.some(item => item.value === value);

export type ProportionValueType = undefined|number|null|string;
export type ProportionFormatType = undefined|number|null;

export const proportionUnitFormat = (unit: string): (value: ProportionValueType) => ProportionFormatType => {
  switch (unit) {
    case ProportionEnum.Hundred:
      return (value: ProportionValueType) => {
        if (!value || Number.isNaN(value)) {
          return 0;
        }
        if (value === 'Infinity') {
          return 100;
        }
        return Number(new Decimal(value).mul(100)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    case ProportionEnum.Thousand:
      return (value: ProportionValueType) => {
        if (!value || Number.isNaN(value)) {
          return 0;
        }
        if (value === 'Infinity') {
          return 100;
        }
        return Number(new Decimal(value).mul(1000)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    case ProportionEnum.TenThousand:
      return (value: ProportionValueType) => {
        if (!value || Number.isNaN(value)) {
          return 0;
        }
        if (value === 'Infinity') {
          return 100;
        }
        return Number(new Decimal(value).mul(10000)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    default:
      return () => 0;
  }
};

export const msTimeUnitFormat = (unit: string): (value: ProportionValueType) => ProportionFormatType => {
  switch (unit) {
    case TimeEnum.Ms:
      return (value: ProportionValueType) => (value ? parseInt(String(value), 10) : 0);
    case TimeEnum.S:
      return (value: ProportionValueType) => (value
        ? Number(new Decimal(parseInt(String(value), 10)).div(1000)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString()) : 0);
    case TimeEnum.Min:
      return (value: ProportionValueType) => (value
        ? Number(new Decimal(parseInt(String(value), 10)).div(1000)
          .div(60)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString()) : 0);
    default:
      return (value: ProportionValueType) => (value ? Number(value) : 0);
  }
};

export const byteMemoryUnitFormat = (unit: string): (value: ProportionValueType) => ProportionFormatType => {
  const toNumber = (value: ProportionValueType) => {
    if (value === undefined || value === null || value === '' || value === 'Infinity') return 0;
    const num = Number(value);
    return Number.isNaN(num) ? 0 : num;
  };
  switch (unit) {
    case MemoryEnum.KB:
      return (value: ProportionValueType) => {
        const num = toNumber(value);
        return Number(new Decimal(num).div(1024)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    case MemoryEnum.MB:
      return (value: ProportionValueType) => {
        const num = toNumber(value);
        return Number(new Decimal(num).div(1024)
          .div(1024)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    case MemoryEnum.GB:
      return (value: ProportionValueType) => {
        const num = toNumber(value);
        return Number(new Decimal(num).div(1024)
          .div(1024)
          .div(1024)
          .toDecimalPlaces(4, Decimal.ROUND_DOWN)
          .toString());
      };
    default:
      return (value: ProportionValueType) => toNumber(value);
  }
};
